import Monster, { MonsterConfig } from "../Monster";
import OneTimeMobGenerator from "./OneTimeMobGenerator";

export default class IntervalMobGenerator extends OneTimeMobGenerator {
    public IntervalSpawnSeconds: number;
    public TimesLimit: number;

    private mAmountOfTimesUsed = 0;
    constructor(mobConfig: MonsterConfig[]) {
        super(mobConfig);
    }

    ShouldGenerate(elapsedSeconds: number): boolean {
        let isStillInDuration = elapsedSeconds / 60 <= this.DurationActiveMinutes;
        let hasPassedDelay = elapsedSeconds >= this.DelaySecondUntilBegin;
        let hasPassedLastInterval = elapsedSeconds % this.IntervalSpawnSeconds == 0;
        let beforeLimit = this.TimesLimit != undefined ? this.mAmountOfTimesUsed < this.TimesLimit : true;

        return isStillInDuration &&
            hasPassedDelay &&
            hasPassedLastInterval &&
            beforeLimit &&
            this.IsActive;
    }

    Generate(): Monster[] {
        this.mAmountOfTimesUsed++;
        return super.Generate();
    }

};